/**
 * AURA Translation Dictionaries
 * Language-specific string sets for the i18n system
 */

import type { TranslationSet } from './i18n';

export const EN: TranslationSet = {
  panelTitle: 'Accessibility Adjustments',
  close: 'Close',
  resetSettings: 'Reset Settings',
  statement: 'Statement',
  hideInterface: 'Hide Interface',
  searchPlaceholder: 'Unclear content? Search in dictionary...',
  tabProfiles: 'Profiles',
  tabContent: 'Content',
  tabColors: 'Colors',
  tabOrientation: 'Orientation',
  profilesHeading: 'Choose the right accessibility profile for you',
  seizureSafe: 'Seizure Safe Profile',
  seizureSafeDesc: 'Clear flashes & reduces color',
  visionImpaired: 'Vision Impaired Profile',
  visionImpairedDesc: "Enhances website's visuals",
  adhdFriendly: 'ADHD Friendly Profile',
  adhdFriendlyDesc: 'More focus & fewer distractions',
  cognitiveDisability: 'Cognitive Disability Profile',
  cognitiveDisabilityDesc: 'Assists with reading & focusing',
  keyboardNavigation: 'Keyboard Navigation (Motor)',
  keyboardNavigationDesc: 'Use website with the keyboard',
  screenReader: 'Blind Users (Screen Reader)',
  screenReaderDesc: 'Optimize website for screen-readers',
  contentAdjustments: 'Content Adjustments',
  contentScaling: 'Content Scaling',
  fontSizing: 'Font Sizing',
  lineHeight: 'Line Height',
  letterSpacing: 'Letter Spacing',
  readableFont: 'Readable Font',
  highlightTitles: 'Highlight Titles',
  highlightLinks: 'Highlight Links',
  textMagnifier: 'Text Magnifier',
  colorAdjustments: 'Color Adjustments',
  contrast: 'Contrast',
  darkContrast: 'Dark Contrast',
  lightContrast: 'Light Contrast',
  highContrast: 'High Contrast',
  saturation: 'Saturation',
  highSaturation: 'High Saturation',
  lowSaturation: 'Low Saturation',
  monochrome: 'Monochrome',
  customColors: 'Custom Colors',
  textColor: 'Text Color',
  titleColor: 'Title Color',
  backgroundColor: 'Background Color',
  orientationAdjustments: 'Orientation Adjustments',
  mediaAndMotion: 'Media & Motion',
  muteSounds: 'Mute Sounds',
  hideImages: 'Hide Images',
  stopAnimations: 'Stop Animations',
  readingAids: 'Reading Aids',
  readMode: 'Read Mode',
  readingGuide: 'Reading Guide',
  readingMask: 'Reading Mask',
  focusAndNavigation: 'Focus & Navigation',
  highlightHover: 'Highlight Hover',
  highlightFocus: 'Highlight Focus',
  cursor: 'Cursor',
  bigBlackCursor: 'Big Black Cursor',
  bigWhiteCursor: 'Big White Cursor',
  accessibilityStatement: 'Accessibility Statement',
  poweredBy: 'Powered by AURA',
  learnMore: 'Learn More',
  statementTitle: 'Accessibility Statement',
  statementClose: 'Close',
  on: 'ON',
  off: 'OFF',
};

export const ES: TranslationSet = {
  panelTitle: 'Ajustes de Accesibilidad',
  close: 'Cerrar',
  resetSettings: 'Restablecer',
  statement: 'Declaración',
  hideInterface: 'Ocultar Interfaz',
  searchPlaceholder: '¿Contenido confuso? Buscar en diccionario...',
  tabProfiles: 'Perfiles',
  tabContent: 'Contenido',
  tabColors: 'Colores',
  tabOrientation: 'Orientación',
  profilesHeading: 'Elige el perfil de accesibilidad adecuado para ti',
  seizureSafe: 'Perfil Seguro para Convulsiones',
  seizureSafeDesc: 'Elimina destellos y reduce color',
  visionImpaired: 'Perfil de Discapacidad Visual',
  visionImpairedDesc: 'Mejora los elementos visuales',
  adhdFriendly: 'Perfil TDAH',
  adhdFriendlyDesc: 'Más enfoque y menos distracciones',
  cognitiveDisability: 'Perfil de Discapacidad Cognitiva',
  cognitiveDisabilityDesc: 'Ayuda con la lectura y el enfoque',
  keyboardNavigation: 'Navegación por Teclado (Motor)',
  keyboardNavigationDesc: 'Usar sitio web con el teclado',
  screenReader: 'Usuarios Ciegos (Lector de Pantalla)',
  screenReaderDesc: 'Optimizar sitio para lectores de pantalla',
  contentAdjustments: 'Ajustes de Contenido',
  contentScaling: 'Escala de Contenido',
  fontSizing: 'Tamaño de Fuente',
  lineHeight: 'Altura de Línea',
  letterSpacing: 'Espaciado de Letras',
  readableFont: 'Fuente Legible',
  highlightTitles: 'Resaltar Títulos',
  highlightLinks: 'Resaltar Enlaces',
  textMagnifier: 'Lupa de Texto',
  colorAdjustments: 'Ajustes de Color',
  contrast: 'Contraste',
  darkContrast: 'Contraste Oscuro',
  lightContrast: 'Contraste Claro',
  highContrast: 'Alto Contraste',
  saturation: 'Saturación',
  highSaturation: 'Alta Saturación',
  lowSaturation: 'Baja Saturación',
  monochrome: 'Monocromo',
  customColors: 'Colores Personalizados',
  textColor: 'Color de Texto',
  titleColor: 'Color de Título',
  backgroundColor: 'Color de Fondo',
  orientationAdjustments: 'Ajustes de Orientación',
  mediaAndMotion: 'Medios y Movimiento',
  muteSounds: 'Silenciar Sonidos',
  hideImages: 'Ocultar Imágenes',
  stopAnimations: 'Detener Animaciones',
  readingAids: 'Ayudas de Lectura',
  readMode: 'Modo Lectura',
  readingGuide: 'Guía de Lectura',
  readingMask: 'Máscara de Lectura',
  focusAndNavigation: 'Enfoque y Navegación',
  highlightHover: 'Resaltar Hover',
  highlightFocus: 'Resaltar Foco',
  cursor: 'Cursor',
  bigBlackCursor: 'Cursor Negro Grande',
  bigWhiteCursor: 'Cursor Blanco Grande',
  accessibilityStatement: 'Declaración de Accesibilidad',
  poweredBy: 'Desarrollado por AURA',
  learnMore: 'Más Información',
  statementTitle: 'Declaración de Accesibilidad',
  statementClose: 'Cerrar',
  on: 'SÍ',
  off: 'NO',
};

export const FR: TranslationSet = {
  panelTitle: "Réglages d'Accessibilité",
  close: 'Fermer',
  resetSettings: 'Réinitialiser',
  statement: 'Déclaration',
  hideInterface: "Masquer l'Interface",
  searchPlaceholder: 'Contenu flou ? Rechercher dans le dictionnaire...',
  tabProfiles: 'Profils',
  tabContent: 'Contenu',
  tabColors: 'Couleurs',
  tabOrientation: 'Orientation',
  profilesHeading: "Choisissez le bon profil d'accessibilité",
  seizureSafe: 'Profil Anti-Crise',
  seizureSafeDesc: 'Supprime les flashs et réduit les couleurs',
  visionImpaired: 'Profil Déficience Visuelle',
  visionImpairedDesc: 'Améliore les visuels du site',
  adhdFriendly: 'Profil TDAH',
  adhdFriendlyDesc: 'Plus de concentration, moins de distractions',
  cognitiveDisability: 'Profil Handicap Cognitif',
  cognitiveDisabilityDesc: 'Aide à la lecture et à la concentration',
  keyboardNavigation: 'Navigation Clavier (Moteur)',
  keyboardNavigationDesc: 'Utiliser le site au clavier',
  screenReader: 'Utilisateurs Aveugles (Lecteur Écran)',
  screenReaderDesc: "Optimiser le site pour les lecteurs d'écran",
  contentAdjustments: 'Ajustements du Contenu',
  contentScaling: 'Échelle du Contenu',
  fontSizing: 'Taille de Police',
  lineHeight: 'Hauteur de Ligne',
  letterSpacing: 'Espacement des Lettres',
  readableFont: 'Police Lisible',
  highlightTitles: 'Surligner les Titres',
  highlightLinks: 'Surligner les Liens',
  textMagnifier: 'Loupe de Texte',
  colorAdjustments: 'Ajustements de Couleur',
  contrast: 'Contraste',
  darkContrast: 'Contraste Sombre',
  lightContrast: 'Contraste Clair',
  highContrast: 'Contraste Élevé',
  saturation: 'Saturation',
  highSaturation: 'Haute Saturation',
  lowSaturation: 'Basse Saturation',
  monochrome: 'Monochrome',
  customColors: 'Couleurs Personnalisées',
  textColor: 'Couleur du Texte',
  titleColor: 'Couleur du Titre',
  backgroundColor: 'Couleur de Fond',
  orientationAdjustments: "Ajustements d'Orientation",
  mediaAndMotion: 'Médias et Mouvement',
  muteSounds: 'Couper le Son',
  hideImages: 'Masquer les Images',
  stopAnimations: 'Arrêter les Animations',
  readingAids: 'Aides à la Lecture',
  readMode: 'Mode Lecture',
  readingGuide: 'Guide de Lecture',
  readingMask: 'Masque de Lecture',
  focusAndNavigation: 'Focus et Navigation',
  highlightHover: 'Surligner le Survol',
  highlightFocus: 'Surligner le Focus',
  cursor: 'Curseur',
  bigBlackCursor: 'Grand Curseur Noir',
  bigWhiteCursor: 'Grand Curseur Blanc',
  accessibilityStatement: "Déclaration d'Accessibilité",
  poweredBy: 'Propulsé par AURA',
  learnMore: 'En Savoir Plus',
  statementTitle: "Déclaration d'Accessibilité",
  statementClose: 'Fermer',
  on: 'OUI',
  off: 'NON',
};

export const TRANSLATIONS: Record<string, TranslationSet> = {
  en: EN,
  es: ES,
  fr: FR,
};
